import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const PeopleInHouseholdFilterIcon = (props: any) => {
  const theme = useContext(ThemeContext);
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0.917969 15.8333C0.917969 16.2475 1.25376 16.5833 1.66797 16.5833C2.08218 16.5833 2.41797 16.2475 2.41797 15.8333H0.917969ZM10.918 15.8333C10.918 16.2475 11.2538 16.5833 11.668 16.5833C12.0822 16.5833 12.418 16.2475 12.418 15.8333H10.918ZM2.41797 15.8333C2.41797 14.4142 3.58218 13.25 5.0013 13.25V11.75C2.75376 11.75 0.917969 13.5858 0.917969 15.8333H2.41797ZM5.0013 13.25H8.33464V11.75H5.0013V13.25ZM8.33464 13.25C9.75375 13.25 10.918 14.4142 10.918 15.8333H12.418C12.418 13.5858 10.5822 11.75 8.33464 11.75V13.25Z"
        fill={theme.colors.neutrals.c400}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="transparent"
      />
      <path
        d="M8.7512 5.00029C9.91787 6.16696 9.91787 8.00029 8.7512 9.08362C7.58453 10.167 5.7512 10.2503 4.66787 9.08362C3.58453 7.91696 3.5012 6.16696 4.58453 5.00029C5.66787 3.83362 7.58453 3.91696 8.7512 5.00029"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M13.3359 10.918C12.9217 10.918 12.5859 11.2538 12.5859 11.668C12.5859 12.0822 12.9217 12.418 13.3359 12.418V10.918ZM17.5859 14.168C17.5859 14.5822 17.9217 14.918 18.3359 14.918C18.7502 14.918 19.0859 14.5822 19.0859 14.168H17.5859ZM13.3359 12.418H15.8359V10.918H13.3359V12.418ZM15.8359 12.418C16.8384 12.418 17.5859 13.1655 17.5859 14.168H19.0859C19.0859 12.3371 17.6668 10.918 15.8359 10.918V12.418Z"
        fill={theme.colors.neutrals.c400}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="transparent"
      />
      <path
        d="M16.085 5.58594C16.9184 6.41927 16.9184 7.7526 16.085 8.5026C15.2517 9.25261 13.9184 9.33594 13.1684 8.5026C12.4184 7.66927 12.335 6.33594 13.1684 5.58594C13.9184 4.83594 15.2517 4.83594 16.085 5.58594"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </svg>
  );
};

export default PeopleInHouseholdFilterIcon;
